<template>
	<div class="cooperation_unit clear_both">
		<div class="l">
			<div class="l_txt">
				<h1 class="title">合作单位</h1>
				<h1 class="en_title"><span>COOPERATION UNIT</span></h1>
			</div>
		</div>
		<div class="r">
			<div class="swiper_box">
				<div class="swiper-container" style="height: 100%;">
					<div class="swiper-wrapper">
						<div class="swiper-slide">
							<div v-for="(v, i) in list_01" :key="i" class="item">
								<div class="item_logo">
									<img :src="v.logo" alt="">
								</div>
								<p class="item_desc text_one" style="margin-top: 5px;">{{ v.title }}</p>
								<p class="item_desc text_one">{{ v.subTitle || '' }}</p>
							</div>
						</div>
						<div class="swiper-slide">
							<div v-for="(v, i) in list_02" :key="i" class="item">
								<div class="item_logo">
									<img :src="v.logo" alt="">
								</div>
								<p class="item_desc text_one" style="margin-top: 5px;">{{ v.title }}</p>
								<p class="item_desc text_one">{{ v.subTitle || '' }}</p>
							</div>
						</div>
						<div class="swiper-slide">
							<div v-for="(v, i) in list_03" :key="i" class="item">
								<div class="item_logo">
									<img :src="v.logo" alt="">
								</div>
								<p class="item_desc text_one" style="margin-top: 5px;">{{ v.title }}</p>
								<p class="item_desc text_one">{{ v.subTitle || '' }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="swiper_control">
				<i class="prev" @click="handlePrevClick"></i>
				<i class="next" @click="handleNextClick"></i>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		mounted() {
			this.initSwiper();
		},
		data() {
			return {
				list_01: [{
					logo: require('../../../../assets/cooperation_unit_12.png'),
					title: '中国科学技术大学',
					subTitle: '先进技术研究院'
				}, {
					logo: require('../../../../assets/cooperation_unit_13.png'),
					title: '中国科学院脑功能与',
					subTitle: '脑疾病重点实验室'
				}, {
					logo: require('../../../../assets/cooperation_unit_09.png'),
					title: '中国科学技术大学',
					subTitle: '视觉研究实验室'
				}, {
					logo: require('../../../../assets/cooperation_unit_01.png'),
					title: '欧普康视'
				}, {
					logo: require('../../../../assets/cooperation_unit_02.png'),
					title: '南京医科大学',
					subTitle: '视觉与认知研究中心'
				}, {
					logo: require('../../../../assets/cooperation_unit_03.png'),
					title: '天津医科大学',
					subTitle: '眼科医院'
				}, {
					logo: require('../../../../assets/cooperation_unit_14.jpg'),
					title: '爱尔眼科集团医院',
					subTitle: '（部分）'
				}, {
					logo: require('../../../../assets/cooperation_unit_15.jpg'),
					title: '安徽省立医院'
				}],
				list_02: [{
					logo: require('../../../../assets/cooperation_unit_16.jpg'),
					title: '安徽医科大学',
					subTitle: '第一附属医院'
				}, {
					logo: require('../../../../assets/cooperation_unit_17.jpg'),
					title: '北京市儿童医院'
				}, {
					logo: require('../../../../assets/cooperation_unit_18.jpg'),
					title: '华夏集团眼科医院',
					subTitle: '（部分）'
				}, {
					logo: require('../../../../assets/cooperation_unit_19.jpg'),
					title: '山东省立医院'
				}, {
					logo: require('../../../../assets/cooperation_unit_20.jpg'),
					title: '南京市妇幼保健院'
				}, {
					logo: require('../../../../assets/cooperation_unit_04.png'),
					title: '安徽讯飞产业投资',
					subTitle: '有限责任公司'
				}, {
					logo: require('../../../../assets/cooperation_unit_10.png'),
					title: '加拿大麦吉尔大学'
				}, {
					logo: require('../../../../assets/cooperation_unit_06.png'),
					title: '美国加州大学',
					subTitle: '洛杉矶分校'
				}],
				list_03: [{
					logo: require('../../../../assets/cooperation_unit_07.png'),
					title: '美国佛罗里达大学'
				}, {
					logo: require('../../../../assets/cooperation_unit_08.png'),
					title: '美国密西西比州大学'
				}, {
					logo: require('../../../../assets/cooperation_unit_05.png'),
					title: '美国南加州大学'
				}]
			}
		},
		methods: {
			/***************** @Events **********************/
			// 点击上一页
			handlePrevClick() {
				this.swiper_instance.slidePrev(300);
			},
			// 点击下一页
			handleNextClick() {
				this.swiper_instance.slideNext(300);
			},
			
			/***************** @Function **********************/
			// 初始化swiper
			initSwiper() {
				this.swiper_instance = new this.Swiper('.cooperation_unit .swiper-container', {
					loop: false,
					allowTouchMove: false
				});
			}
		}
	}
</script>

<style scoped>
	.cooperation_unit{ width: 1200px;margin: 0 auto;padding: 130px 0; }
	.cooperation_unit .l{ position: relative;float: left;width: 437px;height: 516px;border-radius: 10px;background-image: url(../../../../assets/cooperation_unit.png);background-size: cover;background-position: center center; }
	.cooperation_unit .l_txt{ position: absolute;width: 256px;top: 24px;left: 242px; }
	.cooperation_unit .l_txt .title{ font-size: 30px;font-weight: bold;line-height: 42px; }
	.cooperation_unit .l_txt .en_title{ position: relative;font-size: 24px;color: #999;line-height: 34px; }
	.cooperation_unit .l_txt .en_title::before{ content: "";display: block;position: absolute;width: 256px;height: 11px;top: 18px;left: 0;background: #ffb805; }
	.cooperation_unit .l_txt .en_title span{ display: block;position: relative;z-index: 9; }
	
	.cooperation_unit .r{ float: right;width: 660px;padding: 36px 0 0 0; }
	.cooperation_unit .swiper_box{ height: 440px; }
	.cooperation_unit .item{ float: left;width: 150px;height: 195px;margin: 0 20px 25px 0; }
	.cooperation_unit .item:nth-child(4n){ margin-right: 0; }
	.cooperation_unit .item_logo{ width: 100%;height: 150px;padding: 7px; }
	.cooperation_unit .item_logo img{ display: block;width: 100%;height: 100%; }
	.cooperation_unit .item_desc{ height: 20px;font-size: 16px;color: #333;text-align: center;line-height: 20px; }
	.cooperation_unit .swiper_control{ text-align: right; }
	.cooperation_unit .prev{ display: inline-block;width: 40px;height: 40px;margin-right: 16px;background-image: url(../../../../assets/prev_circle_icon.png);background-size: cover;vertical-align: top; }
	.cooperation_unit .next{ display: inline-block;width: 40px;height: 40px;background-image: url(../../../../assets/next_circle_icon.png);background-size: cover;vertical-align: top; }
	.cooperation_unit .prev:hover{ background-image: url(../../../../assets/prev_on_circle_icon.png);background-size: cover;cursor: pointer; }
	.cooperation_unit .next:hover{ background-image: url(../../../../assets/next_on_circle_icon.png);background-size: cover;cursor: pointer; }
</style>
